export const experience = [
  {
    year: '2025',
    works: [
      {
        name: 'Software Engineering Consultant',
        company: 'CoCarting, USA',
        desc: 'Developed and optimized React Native and Next.js features, managed CI/CD releases for iOS/Android, and collaborated across teams to ensure seamless UI/UX and scalable architecture.',
      },
    ],
  },
  {
    year: '2024',
    works: [
      {
        name: 'Frontend Engineer',
        company: 'Neptune Technologies, USA',
        desc: 'Architected high-performance React/Next.js apps, built cross-platform features with React Native + Firebase/AWS, and improved deployment reliability using GitHub Actions CI/CD.',
      },
      {
        name: 'Lead Software Engineer',
        company: '7000 Languages, Boston',
        desc: 'Led development of the 7000 Languages mobile app using React Native, Node.js, Firebase, AWS, and MongoDB Realm, improving performance and increasing user retention by 20%.',
      },
    ],
  },
  {
    year: '2023',
    works: [
      {
        name: 'Lead Software Engineer',
        company: '7000 Languages, Boston',
        desc: 'Directed mobile engineering efforts, integrated new product features, and enhanced app performance and user experience across React Native and backend systems.',
      },
      {
        name: 'Augmented Reality Software Engineer',
        company: 'Crowdbotics, Berkeley, USA',
        desc: 'Built production-ready AR experiences using Unity 3D, AR Foundation, and React Native, achieving 30–40% tracking improvements and delivering polished interactive scenes.',
      },
    ],
  },
  {
    year: '2022',
    works: [
      {
        name: 'Augmented Reality Software Engineer',
        company: 'Crowdbotics, Berkeley, USA',
        desc: 'Developed AR features including image recognition and object detection, optimized performance via asset compression and memory profiling, and shipped the Santa Magic app.',
      },
      {
        name: 'Founder & Unity Game Developer',
        company: 'Immerxity, Buea',
        desc: 'Created immersive AR/VR and 3D experiences with Unity and C#, integrating animations, interactions, and optimized scenes for Android, iOS, and Meta Quest.',
      },
    ],
  },
  {
    year: '2021',
    works: [
      {
        name: 'React Native Trainer & Product Releaser',
        company: 'MindHome, USA',
        desc: 'Trained engineering teams on React/React Native and led product releases for mobile and web platforms, supporting adoption by the first 100+ users.',
      },
    ],
  },
  {
    year: '2020',
    works: [
      {
        name: 'Software Engineer',
        company: 'Digital Renter, Buea',
        desc: 'Built major React Native app screens, upgraded the Laravel web platform, developed the CMS using Laravel Jobs/Schedulers/Events, and deployed infrastructure on AWS EC2 and S3.',
      },
    ],
  },
];
